export default {
  data() {
    return {
      dragStartContainerOffset: {x: 0, y: 0},
      dragStartMouseOffset: {x: 0, y: 0},
    }
  },
  methods: {
    attachMoveEvent() {
      window.addEventListener('mousemove', this.onMouseMove)
      window.addEventListener('mouseup', this.detachMoveEvent)
    },
    detachMoveEvent() {
      window.removeEventListener('mousemove', this.onMouseMove)
      window.removeEventListener('mouseup', this.detachMoveEvent)
    },
    onMouseMove(e) {
      const gapX = e.clientX - this.dragStartMouseOffset.x
      const gapY = e.clientY - this.dragStartMouseOffset.y
      let targetX = Math.max(this.dragStartContainerOffset.x + gapX, 0)
      let targetY = Math.max(this.dragStartContainerOffset.y + gapY, 0)
      this.$el.style.left = `${targetX}px`
      this.$el.style.top = `${targetY}px`
      e.preventDefault()
    },
    dragStart(e) {
      if (e.target.closest('.popClose')) return
      e.preventDefault();
      this.dragStartMouseOffset.x = e.clientX
      this.dragStartMouseOffset.y = e.clientY
      this.dragStartContainerOffset.x = this.$el.offsetLeft
      this.dragStartContainerOffset.y = this.$el.offsetTop
      this.attachMoveEvent()
    },
    moveToCenter() {
      const halfWidth = this.$el.offsetWidth / 2
      const halfHeight = this.$el.offsetHeight / 2
      const scrollPosition = getScrollPosition()
      let targetX = Math.max(window.innerWidth/2 + scrollPosition.x - halfWidth, 0)
      let targetY = Math.max(window.innerHeight/2 + scrollPosition.y - halfHeight, 0)
      
      this.$el.style.left = `${targetX}px`
      this.$el.style.top = `${targetY}px`
    }
  },
  mounted() {
    this.moveToCenter();
  }
}

function getScrollPosition() {
  return {
    x: window.pageXOffset || document.documentElement.scrollLeft || 0,
    y: window.pageYOffset || document.documentElement.scrollTop || 0
  }
}